import type { Business } from "@/types/directory";
import BusinessCard from "@/components/base/BusinessCard";
import SectionHeading from "@/components/base/SectionHeading";

interface LatestListingsProps {
  businesses: Business[];
}

export default function LatestListings({ businesses }: LatestListingsProps) {
  if (businesses.length === 0) {
    return null;
  }

  return (
    <section className="mx-auto w-full max-w-[1400px] px-6 py-14 md:py-16">
      <SectionHeading
        eyebrow="Freshly added"
        title="Recently added businesses"
        description={`${businesses.length} new shops, services and stays that joined the directory this week across the three coastal districts.`}
        action={{ label: "See more listings", to: "/directory?sort=newest" }}
      />

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {businesses.map((business) => (
          <BusinessCard key={business.id} business={business} clickableCard />
        ))}
      </div>
    </section>
  );
}